import { render, staticRenderFns } from "./PublicityForm.vue?vue&type=template&id=70033b96"
import script from "./PublicityForm.vue?vue&type=script&lang=js"
export * from "./PublicityForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports